(function ($) {
	function lang() {
		let langMenu = document.querySelector(
			'#menu-language-switcher ul.sub-menu'
		);
		const sortedLangMenu = document.createElement('ul');
		sortedLangMenu.classList.add('sub-menu');
		const currentLang = document.querySelector(
			'#menu-language-switcher a[href="#pll_switcher"]'
		).textContent;
		Array.from(langMenu.children)
			.sort((a, b) => a.textContent.localeCompare(b.textContent))
			.filter((el) => el.textContent !== currentLang)
			.forEach((el) => sortedLangMenu.appendChild(el));
		if (langMenu) langMenu.replaceWith(sortedLangMenu);
		const mobileLangMenu = document.querySelector(
			'#menu-language-switcher-1 ul.sub-menu'
		);
		if (mobileLangMenu && sortedLangMenu)
			mobileLangMenu.replaceWith(sortedLangMenu.cloneNode(true));
	}
	lang();
})(jQuery);
